<!--电能消耗 usePowerDifference-->
<template>
  <div class="usepowerdifference">
    <div class="con">
      <div class="tree-left">
        <elUnitTree
          :dataList="virtualDeviceList2"
          @checkFun="search"
        ></elUnitTree>
      </div>
      <div class="right-table">
        <div class="el-loading-mask" v-show="isMask">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>

        <div class="search-input-btn" style="width:100%">
          <el-scrollbar style="height:100%;width: 100%;">
            <div class="my-search-i">
              <span style="margin-right: 10px;">能源类型:</span>
              <el-select
                v-model="energyType"
                placeholder="请选择"
                style="width: 90px;"
              >
                <el-option label="水" value="1"> </el-option>
                <el-option label="电" value="2"> </el-option>
                <el-option label="气" value="3"> </el-option>
              </el-select>
              <timeTypeSelection
                @selectTimetype="nowTimetype = $event"
                :userDefined="true"
              ></timeTypeSelection>
              <div class="input-small ">
                <el-date-picker
                  class="picker"
                  v-model="dateValue"
                  :type="timerType"
                  placeholder="请选择日期"
                  :picker-options="pickerOptions"
                  v-show="nowTimetype != 'custom'"
                ></el-date-picker>
                <el-date-picker
                  v-model="customTimer"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                  v-show="nowTimetype == 'custom'"
                >
                </el-date-picker>
              </div>
              <el-button type="primary" plain @click="search" class="search-btn"
                >查询</el-button
              >
              <el-button @click="exportExcel" type="primary" class="search-btn"
                >导出</el-button
              >
              <el-button
                @click="heji"
                plain
                :type="heji_status ? 'warning' : 'success'"
                class="search-btn"
                >{{ heji_status ? "切换" : "合计" }}</el-button
              >
            </div>
          </el-scrollbar>
        </div>
        <vchart style="height: 50%;" ref="vchart"></vchart>
        <!--表格显示数据-->
        <div class="titled">
          <span>数据报表 (单位：kWh)</span>
          <span
            >总计：<span style="color: red;font-weight: bold;">{{
              summary
            }}</span></span
          >
        </div>
        <div class="mytable" id="printCons">
          <el-table
            :max-height="heights"
            :data="nowPage"
            border
            style="width: 100%"
          >
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据" />
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column label="序号" width="60" align="center" fixed>
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="逆变器" width="220" align="center" fixed>
              <template slot-scope="scope">
                <span>{{ scope.row[0] | date_format }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-for="(column, r) in columns"
              :label="column.name"
              width="120"
              align="center"
              v-if="r && r !== columns.length - 1"
            >
              <template slot-scope="scope">
                <span>{{ scope.row[r] }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="小计"
              width="120"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <span style="color: #a0a700;font-weight: bold; ">{{
                  scope.row[columns.length - 1]
                }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <downloadTable ref="downloadTable"></downloadTable>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { findTreeForUnit, findPhotovoltaicDevice } from "../../api/gfSystem";
import vchart from "@/components/module/chart/vchart.vue";
import timeTypeSelection from "@/components/module/selection/timeTypeSelection.vue";
import variableApi from "../../components/api/variableApi";
import elUnitTree from "@/components/module/newTree/elUnitTree.vue";
import downloadTable from "@/components/module/downloadTable/downloadTable.vue";
export default {
  components: {
    vchart,
    timeTypeSelection,
    downloadTable,
    elUnitTree,
  },
  props: [],
  data() {
    return {
      energyType: "1",
      dataList: [],
      defaultProps: {
        children: "children",
        label: "unitName",
      },
      defaultPropss: {
        children: "children",
        label: "label",
      },
      isMask: false, //遮罩层
      heji_status: true,
      filterText: "",

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      heights: Math.round(document.getElementById("app").clientHeight * 0.32),
      checkedData: [],
      targetApptypeGroups: [
        {
          name: "电",
          no: 36,
        },
        {
          name: "水",
          no: 237,
        },
        {
          name: "气",
          no: 361,
        },
      ],
      nowVirtualDevice: undefined,
      nowTimetype: "day",
      options: {},
      options2: {}, //合计数
      dataObject: {},
      nowIndex: 0,
      pageLen: 5,
      weekList: [
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
        "星期日",
      ],
      from2name: {},
      targetApptype: 36,
      endTime: "",
      endCanSelect: new Date(new Date().getTime() + 60 * 60 * 24),
      radio: 36,
      unit: "",
      summary: "", //合计
      variableTree: [
        {
          next: [
            {
              area: 0,
              fromObject: 11,
              pkid: "e560c6f5-eba8-431a-b110-969542e7cf43",
              dataType: 6,
              typeName: "未定义",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 0,
              typeGroupId: "322b3084ed36478facef59016767d0cc",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.总有功功率",
              name: "永宁机电总进线数显表.总有功功率",
              typeId: "5FDFF98A-9C72-434C-B8BA-28340059BDA6",
              dimmingValue: 100.0,
              id: "e560c6f5-eba8-431a-b110-969542e7cf43",
            },
          ],
          no: 0,
          unit: "",
          datatypetag: 0,
          serialnum: 1,
          createTime: null,
          entityName: "AppTypeGroup",
          isvisable: 0,
          name: "未定义",
          id: "322b3084ed36478facef59016767d0cc",
        },
        {
          next: [
            {
              area: 0,
              fromObject: 11,
              pkid: "4bc18675-4495-449b-b986-2597d0268b4d",
              dataType: 6,
              typeName: "A相电流",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 5,
              typeGroupId: "aec119cd-245d-4432-b97d-1a11646377c0",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.A相电流",
              name: "永宁机电总进线数显表.A相电流",
              typeId: "C22E2981-3627-49EF-A93E-4A3AC1983994",
              dimmingValue: 100.0,
              id: "4bc18675-4495-449b-b986-2597d0268b4d",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "5e0475cd-2e55-4f9b-b243-95038ebdc0ae",
              dataType: 6,
              typeName: "B相电流",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 6,
              typeGroupId: "aec119cd-245d-4432-b97d-1a11646377c0",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.B相电流",
              name: "永宁机电总进线数显表.B相电流",
              typeId: "6EC6E71D-3A7A-4C78-A044-6D8CF4B49ABA",
              dimmingValue: 100.0,
              id: "5e0475cd-2e55-4f9b-b243-95038ebdc0ae",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "8aca6121-1e84-4c86-9b34-5caf4e4284e7",
              dataType: 6,
              typeName: "C相电流",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 7,
              typeGroupId: "aec119cd-245d-4432-b97d-1a11646377c0",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.C相电流",
              name: "永宁机电总进线数显表.C相电流",
              typeId: "412EAD66-2930-4AE8-BDAD-386D2B788A0F",
              dimmingValue: 100.0,
              id: "8aca6121-1e84-4c86-9b34-5caf4e4284e7",
            },
          ],
          no: 1,
          unit: "A",
          datatypetag: 1,
          serialnum: 2,
          createTime: null,
          entityName: "AppTypeGroup",
          isvisable: 0,
          name: "电流",
          id: "aec119cd-245d-4432-b97d-1a11646377c0",
        },
        {
          next: [
            {
              area: 0,
              fromObject: 11,
              pkid: "e23a40e6-50b6-4f25-a429-808f4b318518",
              dataType: 6,
              typeName: "A相电压",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 1,
              typeGroupId: "31ed13da-4c8d-4d80-8ada-a3713762a49d",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.A相电压",
              name: "永宁机电总进线数显表.A相电压",
              typeId: "F7C2BBAE-E12F-4AB3-957A-15EA261D6677",
              dimmingValue: 100.0,
              id: "e23a40e6-50b6-4f25-a429-808f4b318518",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "cf915fce-235c-41c5-8f17-b78a75dd092f",
              dataType: 6,
              typeName: "B相电压",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 2,
              typeGroupId: "31ed13da-4c8d-4d80-8ada-a3713762a49d",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.B相电压",
              name: "永宁机电总进线数显表.B相电压",
              typeId: "2C488892-10FB-41B9-A170-31CA5563477D",
              dimmingValue: 100.0,
              id: "cf915fce-235c-41c5-8f17-b78a75dd092f",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "a0b034af-8125-4995-ba0f-635100614be5",
              dataType: 6,
              typeName: "C相电压",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 3,
              typeGroupId: "31ed13da-4c8d-4d80-8ada-a3713762a49d",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.C相电压",
              name: "永宁机电总进线数显表.C相电压",
              typeId: "3C8785C3-15ED-444F-90EA-EAAFFC43C3AD",
              dimmingValue: 100.0,
              id: "a0b034af-8125-4995-ba0f-635100614be5",
            },
          ],
          no: 2,
          unit: "V",
          datatypetag: 1,
          serialnum: 2,
          createTime: null,
          entityName: "AppTypeGroup",
          isvisable: 0,
          name: "相电压",
          id: "31ed13da-4c8d-4d80-8ada-a3713762a49d",
        },
        {
          next: [
            {
              area: 0,
              fromObject: 11,
              pkid: "c64d01f6-eff0-4f3b-89e6-bc11e042bb2c",
              dataType: 6,
              typeName: "总正向有功电量",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 36,
              typeGroupId: "d9624af6-c056-48d9-aedc-56c08a5d173d",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.正向有功电能",
              name: "永宁机电总进线数显表.正向有功电能",
              typeId: "C8A3319C-8300-46E4-A98F-A26C2A010CA2",
              dimmingValue: 100.0,
              id: "c64d01f6-eff0-4f3b-89e6-bc11e042bb2c",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "2e46e87f-7ba9-4485-8fef-c78b07710201",
              dataType: 6,
              typeName: "总反向有功电量",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 37,
              typeGroupId: "d9624af6-c056-48d9-aedc-56c08a5d173d",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.反向有功电能",
              name: "永宁机电总进线数显表.反向有功电能",
              typeId: "5266277E-6D00-43DF-AB0F-DA75834793B2",
              dimmingValue: 100.0,
              id: "2e46e87f-7ba9-4485-8fef-c78b07710201",
            },
          ],
          no: 3,
          unit: "kWh",
          datatypetag: 1,
          serialnum: 3,
          createTime: null,
          entityName: "AppTypeGroup",
          isvisable: 0,
          name: "有功电能",
          id: "d9624af6-c056-48d9-aedc-56c08a5d173d",
        },
        {
          next: [
            {
              area: 0,
              fromObject: 11,
              pkid: "65b4e497-9273-41ea-a117-71eb96a71017",
              dataType: 6,
              typeName: "A相有功功率",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 19,
              typeGroupId: "cf19635a-e5b7-4aec-b0e3-b8acd85ba8ce",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.A相有功功率",
              name: "永宁机电总进线数显表.A相有功功率",
              typeId: "67DB5C00-79A2-4A6E-9C15-42CE6BE7A77B",
              dimmingValue: 100.0,
              id: "65b4e497-9273-41ea-a117-71eb96a71017",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "c0b79da3-ec64-4de1-8690-c0a6867be545",
              dataType: 6,
              typeName: "B相有功功率",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 20,
              typeGroupId: "cf19635a-e5b7-4aec-b0e3-b8acd85ba8ce",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.B相有功功率",
              name: "永宁机电总进线数显表.B相有功功率",
              typeId: "383C3657-D260-4A54-94E8-6C8998182118",
              dimmingValue: 100.0,
              id: "c0b79da3-ec64-4de1-8690-c0a6867be545",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "cdd4313b-aa07-4b2d-9b21-04ba36318167",
              dataType: 6,
              typeName: "C相有功功率",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 21,
              typeGroupId: "cf19635a-e5b7-4aec-b0e3-b8acd85ba8ce",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.C相有功功率",
              name: "永宁机电总进线数显表.C相有功功率",
              typeId: "3349E75F-2BA1-4AA4-B67F-6761E78B986E",
              dimmingValue: 100.0,
              id: "cdd4313b-aa07-4b2d-9b21-04ba36318167",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "d9781852-fff5-40cb-a697-75a5c4118ccd",
              dataType: 6,
              typeName: "合相有功功率",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 31,
              typeGroupId: "cf19635a-e5b7-4aec-b0e3-b8acd85ba8ce",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.ATM",
              name: "永宁机电总进线数显表.ATM",
              typeId: "355F2620-E041-442C-80A5-EE5C1FFC576B",
              dimmingValue: 100.0,
              id: "d9781852-fff5-40cb-a697-75a5c4118ccd",
            },
          ],
          no: 4,
          unit: "kW",
          datatypetag: 1,
          serialnum: 4,
          createTime: null,
          entityName: "AppTypeGroup",
          isvisable: 0,
          name: "有功功率",
          id: "cf19635a-e5b7-4aec-b0e3-b8acd85ba8ce",
        },
        {
          next: [
            {
              area: 0,
              fromObject: 11,
              pkid: "10f36967-beb7-4729-8763-8d74a819b904",
              dataType: 6,
              typeName: "频率",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 18,
              typeGroupId: "43e52f5c-cb53-49ed-a939-70305044eaa4",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.频率",
              name: "永宁机电总进线数显表.频率",
              typeId: "3E6FC81B-404A-4A82-8A65-B357C0CDB682",
              dimmingValue: 100.0,
              id: "10f36967-beb7-4729-8763-8d74a819b904",
            },
          ],
          no: 5,
          unit: "Hz",
          datatypetag: 1,
          serialnum: 5,
          createTime: null,
          entityName: "AppTypeGroup",
          isvisable: 0,
          name: "频率",
          id: "43e52f5c-cb53-49ed-a939-70305044eaa4",
        },
        {
          next: [
            {
              area: 0,
              fromObject: 11,
              pkid: "31aa5b05-6da9-4548-a2e6-d98ed6c42309",
              dataType: 0,
              typeName: "尖",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 351,
              typeGroupId: "fb851bbfd23b44cea50ac7cbb62ddd5d",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.正向有功电能_尖",
              name: "永宁机电总进线数显表.正向有功电能_尖",
              typeId: "2b742f3b2538482c95588855cd754d7b",
              dimmingValue: 100.0,
              id: "31aa5b05-6da9-4548-a2e6-d98ed6c42309",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "213a47e5-5838-4acb-97a8-0eb35eaa2d04",
              dataType: 0,
              typeName: "峰",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 352,
              typeGroupId: "fb851bbfd23b44cea50ac7cbb62ddd5d",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.正向有功电能_峰",
              name: "永宁机电总进线数显表.正向有功电能_峰",
              typeId: "60f48d960ee1483286bf7949b67f1e2f",
              dimmingValue: 100.0,
              id: "213a47e5-5838-4acb-97a8-0eb35eaa2d04",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "716d087e-8abc-4e7b-aa64-b04de0921839",
              dataType: 0,
              typeName: "平",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 353,
              typeGroupId: "fb851bbfd23b44cea50ac7cbb62ddd5d",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.正向有功电能_平",
              name: "永宁机电总进线数显表.正向有功电能_平",
              typeId: "2f217207991d4cf4bdbfd9089c80f4f2",
              dimmingValue: 100.0,
              id: "716d087e-8abc-4e7b-aa64-b04de0921839",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "3191c0dc-a301-4adf-9d04-3a8e6dd9e196",
              dataType: 0,
              typeName: "谷",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 354,
              typeGroupId: "fb851bbfd23b44cea50ac7cbb62ddd5d",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.正向有功电能_谷",
              name: "永宁机电总进线数显表.正向有功电能_谷",
              typeId: "3c7fd03f0a2941fd8c8c36424e8963c2",
              dimmingValue: 100.0,
              id: "3191c0dc-a301-4adf-9d04-3a8e6dd9e196",
            },
          ],
          no: 60,
          unit: "kWh",
          datatypetag: 0,
          serialnum: 8,
          createTime: null,
          entityName: "AppTypeGroup",
          isvisable: 0,
          name: "总尖峰平谷",
          id: "fb851bbfd23b44cea50ac7cbb62ddd5d",
        },
        {
          next: [
            {
              area: 0,
              fromObject: 11,
              pkid: "6ac7ac36-53f8-495c-896f-168dd347e29a",
              dataType: 6,
              typeName: "A相功率因数",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 28,
              typeGroupId: "66bc34d4302f485b8a185cb1d4677592",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.A相功率因数",
              name: "永宁机电总进线数显表.A相功率因数",
              typeId: "29768F31-0BB4-49DE-AB01-4907B53F9A0B",
              dimmingValue: 100.0,
              id: "6ac7ac36-53f8-495c-896f-168dd347e29a",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "bee6c6ae-82ed-46e4-bdb7-947b821950ce",
              dataType: 6,
              typeName: "B相功率因数",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 29,
              typeGroupId: "66bc34d4302f485b8a185cb1d4677592",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.B相功率因数",
              name: "永宁机电总进线数显表.B相功率因数",
              typeId: "381F3606-26AC-4C78-8BDD-AE276C6A0ED8",
              dimmingValue: 100.0,
              id: "bee6c6ae-82ed-46e4-bdb7-947b821950ce",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "fed54267-b438-4851-80ff-4f245fe9fe09",
              dataType: 6,
              typeName: "C相功率因数",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 30,
              typeGroupId: "66bc34d4302f485b8a185cb1d4677592",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.C相功率因数",
              name: "永宁机电总进线数显表.C相功率因数",
              typeId: "3B05C554-7C8D-4093-B56D-CF289166B7C6",
              dimmingValue: 100.0,
              id: "fed54267-b438-4851-80ff-4f245fe9fe09",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "83deb416-ab05-4ca2-8ba7-02f370878f94",
              dataType: 6,
              typeName: "合相功率因数",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 34,
              typeGroupId: "66bc34d4302f485b8a185cb1d4677592",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.总功率因数",
              name: "永宁机电总进线数显表.总功率因数",
              typeId: "F3F7C528-F229-4499-BE6B-9FC1A707BB2D",
              dimmingValue: 100.0,
              id: "83deb416-ab05-4ca2-8ba7-02f370878f94",
            },
          ],
          no: 13,
          unit: "cosφ",
          datatypetag: 1,
          serialnum: 12,
          createTime: null,
          entityName: "AppTypeGroup",
          isvisable: 0,
          name: "功率因数",
          id: "66bc34d4302f485b8a185cb1d4677592",
        },
        {
          next: [
            {
              area: 0,
              fromObject: 11,
              pkid: "c33c2473-e2f5-4134-9a82-db134fb7afd7",
              dataType: 6,
              typeName: "A相无功功率",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 22,
              typeGroupId: "baf429044ce84086bea7cdaec8cbc819",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.A相无功功率",
              name: "永宁机电总进线数显表.A相无功功率",
              typeId: "728D59C6-8599-417C-AB52-CC633D591B61",
              dimmingValue: 100.0,
              id: "c33c2473-e2f5-4134-9a82-db134fb7afd7",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "40d72d7a-dd28-4118-bbfd-7dab3dd20ad0",
              dataType: 6,
              typeName: "B相无功功率",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 23,
              typeGroupId: "baf429044ce84086bea7cdaec8cbc819",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.B相无功功率",
              name: "永宁机电总进线数显表.B相无功功率",
              typeId: "AED6FB27-8382-4E84-A337-26148D5CC525",
              dimmingValue: 100.0,
              id: "40d72d7a-dd28-4118-bbfd-7dab3dd20ad0",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "3e020c05-fceb-4ad5-857b-919d78492bda",
              dataType: 6,
              typeName: "C相无功功率",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 24,
              typeGroupId: "baf429044ce84086bea7cdaec8cbc819",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.C相无功功率",
              name: "永宁机电总进线数显表.C相无功功率",
              typeId: "13F793E1-B98D-460A-9DB4-3CBD16C23369",
              dimmingValue: 100.0,
              id: "3e020c05-fceb-4ad5-857b-919d78492bda",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "224f2203-3e36-4d12-a556-2a53be939ff9",
              dataType: 6,
              typeName: "合相无功功率",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 32,
              typeGroupId: "baf429044ce84086bea7cdaec8cbc819",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.总无功功率",
              name: "永宁机电总进线数显表.总无功功率",
              typeId: "780B7997-FBFB-43F6-9611-17F4DDB4EE0F",
              dimmingValue: 100.0,
              id: "224f2203-3e36-4d12-a556-2a53be939ff9",
            },
          ],
          no: 39,
          unit: "kvar",
          datatypetag: 0,
          serialnum: 24,
          createTime: null,
          entityName: "AppTypeGroup",
          isvisable: 0,
          name: "无功功率",
          id: "baf429044ce84086bea7cdaec8cbc819",
        },
        {
          next: [
            {
              area: 0,
              fromObject: 11,
              pkid: "5a13005a-76ad-4f90-869b-df08153e5c44",
              dataType: 6,
              typeName: "A相视在功率",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 25,
              typeGroupId: "d9ea197686464ca792ecb41077fc1573",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.A相视在功率",
              name: "永宁机电总进线数显表.A相视在功率",
              typeId: "19D9A50B-9C4A-418F-A99B-C47DF14ACDD7",
              dimmingValue: 100.0,
              id: "5a13005a-76ad-4f90-869b-df08153e5c44",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "17821003-4bcb-4547-9ca0-3ac138ceebb4",
              dataType: 6,
              typeName: "B相视在功率",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 26,
              typeGroupId: "d9ea197686464ca792ecb41077fc1573",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.B相视在功率",
              name: "永宁机电总进线数显表.B相视在功率",
              typeId: "E055CEB5-C0C4-4B0D-B1CA-1F02D48C0EF4",
              dimmingValue: 100.0,
              id: "17821003-4bcb-4547-9ca0-3ac138ceebb4",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "b9782f60-eb26-4a30-9368-3c51cefca5d4",
              dataType: 6,
              typeName: "C相视在功率",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 27,
              typeGroupId: "d9ea197686464ca792ecb41077fc1573",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.C相视在功率",
              name: "永宁机电总进线数显表.C相视在功率",
              typeId: "E39392DC-4DC7-410C-A47D-203D7175A30C",
              dimmingValue: 100.0,
              id: "b9782f60-eb26-4a30-9368-3c51cefca5d4",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "a8b91d45-b4d6-45aa-9ff8-0581005d75cc",
              dataType: 6,
              typeName: "合相视在功率",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 33,
              typeGroupId: "d9ea197686464ca792ecb41077fc1573",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.总视在功率",
              name: "永宁机电总进线数显表.总视在功率",
              typeId: "4C509362-2172-4C62-829E-071B6F8F4C96",
              dimmingValue: 100.0,
              id: "a8b91d45-b4d6-45aa-9ff8-0581005d75cc",
            },
          ],
          no: 40,
          unit: "kVA",
          datatypetag: 0,
          serialnum: 25,
          createTime: null,
          entityName: "AppTypeGroup",
          isvisable: 0,
          name: "视在功率",
          id: "d9ea197686464ca792ecb41077fc1573",
        },
        {
          next: [
            {
              area: 0,
              fromObject: 11,
              pkid: "ff757c7b-7ed7-4228-a590-e907d7343eea",
              dataType: 6,
              typeName: "AB线电压",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 9,
              typeGroupId: "62aba95d8257461ebeeccc9a23527835",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.AB线电压",
              name: "永宁机电总进线数显表.AB线电压",
              typeId: "BBD32FC9-1981-4316-9621-FFFF2BBBD336",
              dimmingValue: 100.0,
              id: "ff757c7b-7ed7-4228-a590-e907d7343eea",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "da85667a-77d0-42c7-9c76-603992ab8de4",
              dataType: 6,
              typeName: "AC线电压",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 10,
              typeGroupId: "62aba95d8257461ebeeccc9a23527835",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.AC线电压",
              name: "永宁机电总进线数显表.AC线电压",
              typeId: "A153C0D0-687B-47D5-AB36-031747155BD8",
              dimmingValue: 100.0,
              id: "da85667a-77d0-42c7-9c76-603992ab8de4",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "1ffccee4-d0a6-4446-9dd3-0d1b8c77bdc8",
              dataType: 6,
              typeName: "BC线电压",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 11,
              typeGroupId: "62aba95d8257461ebeeccc9a23527835",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.BC线电压",
              name: "永宁机电总进线数显表.BC线电压",
              typeId: "5C380197-E8DA-429D-ACBE-A35C7ACE6E21",
              dimmingValue: 100.0,
              id: "1ffccee4-d0a6-4446-9dd3-0d1b8c77bdc8",
            },
          ],
          no: 43,
          unit: "V",
          datatypetag: 0,
          serialnum: 28,
          createTime: null,
          entityName: "AppTypeGroup",
          isvisable: 0,
          name: "线电压",
          id: "62aba95d8257461ebeeccc9a23527835",
        },
        {
          next: [
            {
              area: 0,
              fromObject: 11,
              pkid: "95d38219-650e-4d9d-ad81-598e3db3acf9",
              dataType: 6,
              typeName: "总正向无功电量",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 38,
              typeGroupId: "fd01ac4c1fc74753b18591f038d765f4",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.正向无功电能",
              name: "永宁机电总进线数显表.正向无功电能",
              typeId: "B7B1E1AA-B53D-4C87-B5CB-8DCE7396D4C3",
              dimmingValue: 100.0,
              id: "95d38219-650e-4d9d-ad81-598e3db3acf9",
            },
            {
              area: 0,
              fromObject: 11,
              pkid: "205b478a-b807-4871-a646-817c00b45a71",
              dataType: 6,
              typeName: "总反向无功电量",
              fromConnect: 4,
              deviceName: "永宁机电总进线数显表",
              typeNo: 39,
              typeGroupId: "fd01ac4c1fc74753b18591f038d765f4",
              createTime: null,
              entityName: "VirtualVariable",
              fromName: "永宁机电总进线数显表.反向无功电能",
              name: "永宁机电总进线数显表.反向无功电能",
              typeId: "6DA62F12-0E90-4017-8B02-06F18BCC1A62",
              dimmingValue: 100.0,
              id: "205b478a-b807-4871-a646-817c00b45a71",
            },
          ],
          no: 44,
          unit: "kvarh",
          datatypetag: 0,
          serialnum: 29,
          createTime: null,
          entityName: "AppTypeGroup",
          isvisable: 0,
          name: "无功电能",
          id: "fd01ac4c1fc74753b18591f038d765f4",
        },
      ],
      timesList: [
        {
          name: "日",
          id: "day",
        },

        {
          name: "月",
          id: "month",
        },

        {
          name: "年",
          id: "year",
        },
        {
          name: "时间段",
          id: "custom",
        },
      ],
      dateValue: new Date(),
      timerType: "date",
      customTimer: [],
    };
  },
  mounted() {
    setTimeout(() => {
      this.search();
    }, 500);
    var date = new Date();
    var str =
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    var today = new Date(str);
    this.customTimer = [today, new Date()];
    debugPage = this;
    //初始化图表
    this.options = this.$refs.vchart.getDefaultOptions();
    (this.options.toolbox = {
      show: true,
      showTitle: false, // 隐藏默认文字，否则两者位置会重叠
      top: "-5",
      right: "50",
      feature: {
        magicType: {
          type: ["line", "bar", "stack", "tiled"],
          title: {
            line: "切换为折线图",
            bar: "切换为柱状图",
            stack: "切换为堆叠",
            tiled: "切换为平铺",
          },
        },

        saveAsImage: {
          show: true,
          title: "下载图片",
        },
      },
    }),
      (this.options.backgroundColor = "#FFFFFF");
    this.options.tooltip.formatter = (params, ticket, callback) => {
      if (params[0].data == undefined) {
        return "";
      }
      var h = params[0].data[0];
      var label = h + "</br>";
      params.forEach((item) => {
        var values;
        if (isnull(item.data[1])) {
          values = "无采集数据";
        } else {
          values = cutDigital(item.data[1]);
        }
        label += item.seriesName + " : " + values + " (kW·h)</br>";
      });
      return label;
    };
    this.options.yAxis = {
      splitLine: {
        show: true,
      },
    };
    switch (this.targetApptype) {
      case 36:
        this.options.title.text = "发电量(KW·h)";
        break;
      case 237:
        this.options.title.text = "用水量(t)";
        break;
      case 361:
        this.options.title.text = "用气量(m³)";
        break;
      case 362:
        this.options.title.text = "用汽量";
        break;
    }
    this.setDataed();
    this.digui(this.virtualDeviceList);
  },

  computed: {
    virtualDeviceList2() {
      var data = this.$store.deviceStore.getters.getReadDeviceTree;
      return isempty(data) ? [] : [deviceList(data)];
    },
    nowTimeInterval() {
      return this.cacheStore.getters.getNowTimeInterval;
    },
    nowUnit() {
      return this.$store.unitStore.getters.getNowUnit;
    },
    unitId() {
      return this.$store.unitStore.state.nowUnit;
    },
    getResourcesByName() {
      return this.$store.resourcesStore.getters.getResourcesByName;
    },
    cacheStore() {
      return this.$store.cacheStore;
    },
    virtualDeviceList() {
      return [];
    },
    datePickerType() {
      switch (this.nowTimetype) {
        case "day":
        case "week":
          return "day";
        case "month":
        case "quarter":
          return "month";
        case "year":
          return "year";
        case "custom":
          return "custom";
      }
    },
    apptypeGroups() {
      //所有已选中的设备所具有的变量类型组
      var list = [];
      var apptypeGroupIds = [];
      this.variableTree.forEach((apptypeGroup) => {
        if (!apptypeGroupIds.includes(apptypeGroup.id)) {
          apptypeGroupIds.push(apptypeGroup.id);
          list.push(apptypeGroup);
        }
      });
      //排序
      return list.sort((a, b) => {
        return a.serialnum - b.serialnum;
      });
    },
    nowSelectDate() {
      return this.cacheStore.getters.getNowSelectDate;
    },

    columns() {
      var list = [
        {
          name: "变量名",
          weight: 3,
        },
      ];
      switch (this.nowTimetype) {
        case "day":
          //取出每个整点值
          for (var i = 0; i < 24; i++) {
            var label =
              (i < 10 ? "0" : "") +
              i +
              ":00-" +
              (i + 1 < 10 ? "0" : "") +
              (i + 1) +
              ":00";
            list.push({
              name: label, //i + ' - ' + (i + 1)
            });
          }
          break;
        case "week":
          for (var i = 0; i < 7; i++) {
            list.push({
              name: this.weekList[i],
            });
          }
          break;
        case "month":
          let lasDay = new Date(
            this.nowSelectDate.format("yyyy"),
            this.nowSelectDate.format("MM"),
            0
          ).getDate();
          for (var i = 1; i <= lasDay; i++) {
            list.push({
              name: i + "日",
            });
          }
          break;
        case "quarter":
          for (var i = 0; i < 3; i++) {
            list.push({
              name: this.getQuarterList(this.nowSelectDate)[i],
            });
          }
          break;
        case "year":
          for (var i = 1; i <= 12; i++) {
            list.push({
              name: i + "月",
            });
          }
          break;
        case "custom":
          var time =
            this.customTimer[1].getTime() - this.customTimer[0].getTime();
          var dayNum = Math.floor(time / (24 * 60 * 60 * 1000)) + 1;
          var value = [];
          if (isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
            value = undefined;
          }
          if (
            this.customTimer[1].getMonth() != this.customTimer[0].getMonth()
          ) {
            var lastmonthNum = dayNum - this.customTimer[1].getDate();
            for (var i = 0; i < lastmonthNum; i++) {
              list.push({
                name:
                  this.customTimer[0].getMonth() +
                  1 +
                  "月" +
                  (this.customTimer[0].getDate() + i) +
                  "日",
              });
            }
            for (var j = 0; j < this.customTimer[1].getDate(); j++) {
              list.push({
                name:
                  this.customTimer[1].getMonth() + 1 + "月" + (j + 1) + "日",
              });
            }
          } else {
            if (
              this.customTimer[0].getDate() == this.customTimer[1].getDate()
            ) {
              list.push({
                name:
                  this.customTimer[1].getMonth() +
                  1 +
                  "月" +
                  this.customTimer[1].getDate() +
                  "日",
              });
            } else {
              for (var i2 = 0; i2 < dayNum; i2++) {
                //l.length
                list.push({
                  name:
                    this.customTimer[0].getMonth() +
                    1 +
                    "月" +
                    (this.customTimer[0].getDate() + i2) +
                    "日",
                });
              }
            }
          }
          break;
      }
      list.push({ name: "小计" });
      return list;
    },
    nowVariableNames() {
      //当前应该显示的变量
      var variableList = [];
      for (var i = 0, len = this.variableTree.length; i < len; i++) {
        this.variableTree[i].next.forEach((v) => {
          if (v.typeNo == this.targetApptype) {
            this.unit = this.variableTree[i].unit;
            this.from2name[v.fromName] = v.name;
            variableList.push(v.fromName);
          }
        });
      }
      return variableList;
    },

    nowVariableNamesS() {
      //当前应该显示的变量
      var variableList = [];
      this.nowDevice.forEach((item) => {
        this.nowVirtualDevice = item;
        for (var i = 0, len = this.variableTree.length; i < len; i++) {
          this.variableTree[i].next.forEach((v) => {
            if (v.typeNo == this.targetApptype) {
              this.from2name[v.fromName] = v.name;
              variableList.push(v.fromName);
            }
          });
        }
      });

      return variableList;
    },
    showDataList() {
      //用于渲染的合并后的数组
      if (isempty(this.dataObject)) {
        return [];
      }
      //取出数据中的有效数据组织为数组
      var list = [];
      var keys = Object.keys(this.dataObject);
      for (var i = 0, len = keys.length; i < len; i++) {
        var key = keys[i];
        var dataList = [];
        if (this.dataObject[key] instanceof Array) {
          dataList = this.dataObject[key].map((i) => {
            if (isNaN(parseFloat(i)) || isnull(parseFloat(i))) {
              return undefined;
            } else {
              return i;
            }
          });
        }

        // if(this.nowTimetype == "month") {
        // 	let lasDay = new Date(this.nowSelectDate.format("yyyy"), this.nowSelectDate.format("MM"), 0).getDate()
        // 	if(lasDay == 30) {
        // 		dataList.shift()
        // 	}
        // }
        //var vList = [key.subByFirstChar('.')]
        var vList = [key];
        vList.addAll(dataList);
        list.push(vList);
      }
      return list.sort();
    },
    chartDataList() {
      //图表使用的数据
      var list = [];
      for (var i = 0, len = this.showDataList.length; i < len; i++) {
        var l = this.showDataList[i];
        var l2 = [this.nowVariableNames[i]]; //变量名称
        switch (this.nowTimetype) {
          case "day":
            //取出每个整点值
            for (var i2 = 1, len2 = 25; i2 < len2; i2++) {
              //l.length
              var value = l[i2];
              if (isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
                value = undefined;
              }
              var label =
                (i2 - 1 < 10 ? "0" : "") +
                (i2 - 1) +
                ":00-" +
                (i2 < 10 ? "0" : "") +
                i2 +
                ":00";
              l2.push([label, value]);
            }
            break;
          case "week":
            for (var i2 = 1, len2 = 8; i2 < len2; i2++) {
              //l.length
              var value = l[i2];
              if (isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
                value = undefined;
              }
              l2.push([this.weekList[i2 - 1], value]);
            }
            break;
          case "month":
            let lasDay =
              new Date(
                this.nowSelectDate.format("yyyy"),
                this.nowSelectDate.format("MM"),
                0
              ).getDate() + 1;
            //判断月份是否有31
            for (var i2 = 1, len2 = lasDay; i2 < len2; i2++) {
              //l.length
              var value = l[i2];
              if (isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
                value = undefined;
              }
              l2.push([i2 + "日", value]);
            }
            break;
          case "quarter":
            for (var i2 = 1, len2 = 4; i2 < len2; i2++) {
              //l.length
              var value = l[i2];
              if (isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
                value = undefined;
              }
              l2.push([this.getQuarterList(this.nowSelectDate)[i2 - 1], value]);
            }
            break;
          case "year":
            for (var i2 = 1, len2 = 13; i2 < len2; i2++) {
              //l.length
              var value = l[i2];
              if (isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
                value = undefined;
              }
              l2.push([i2 + "月", value]);
            }
            break;
          case "custom":
            var time =
              this.customTimer[1].getTime() - this.customTimer[0].getTime();
            var dayNum = Math.floor(time / (24 * 60 * 60 * 1000)) + 1;
            var value = [];
            if (isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
              value = undefined;
            }
            if (
              this.customTimer[1].getMonth() != this.customTimer[0].getMonth()
            ) {
              var lastmonthNum = dayNum - this.customTimer[1].getDate();
              for (var i = 0; i < lastmonthNum; i++) {
                l2.push([
                  this.customTimer[0].getMonth() +
                    1 +
                    "月" +
                    (this.customTimer[0].getDate() + i) +
                    "日",
                  l[i + 1],
                ]);
              }
              for (var j = 0; j < this.customTimer[1].getDate(); j++) {
                l2.push([
                  this.customTimer[1].getMonth() + 1 + "月" + (j + 1) + "日",
                  l[j + lastmonthNum + 1],
                ]);
              }
            } else {
              if (
                this.customTimer[0].getDate() == this.customTimer[1].getDate()
              ) {
                l2.push([
                  this.customTimer[1].getMonth() +
                    1 +
                    "月" +
                    this.customTimer[1].getDate() +
                    "日",
                  l[1],
                ]);
              } else {
                for (var i2 = 0; i2 < dayNum; i2++) {
                  //l.length
                  l2.push([
                    this.customTimer[0].getMonth() +
                      1 +
                      "月" +
                      (this.customTimer[0].getDate() + i2) +
                      "日",
                    l[i2 + 1],
                  ]);
                }
              }
            }
            l2.push([this.customTimer[0].formatByTime(), l[1]]);
            break;
        }
        list.push(l2);
      }
      return list;
    },
    nowPage() {
      return this.showDataList;

      //按照页码来返回当前应该显示的列表
      // return this.showDataList.filter((item,index) => {
      //   return index>=this.nowIndex*this.pageLen&&index<(this.nowIndex+1)*this.pageLen
      // })
    },
    getDateText() {
      return (date, timeInterval) => {
        switch (this.nowTimetype) {
          case "day":
            return date.formatByDate("-");
          case "week":
            return date.formatByDate("-");
          case "month":
            return date.formatByMonth("-");
          case "quarter":
            return date.formatByMonth("-");
          case "year":
            return date.getFullYear() + "";
          case "custom":
            return (
              timeInterval.startDate.formatByDate("/") +
              "—" +
              timeInterval.endDate.formatByDate("/")
            );
        }
      };
    },
  },
  watch: {
    unitId() {},
    nowVirtualDevice(nv, ov) {},
    nowVariableNames(nv, ov) {},
    chartDataList(nv, ov) {
      //重新渲染
      this.reloadChart(nv);
    },
    nowTimetype(nv, ov) {
      this.search();
      if (nv == "day") {
        this.timerType = "date";
      } else {
        this.timerType = nv;
      }
    },
    nowSelectDate(nv, ov) {},
    nowTimeInterval(nv, ov) {},
    targetApptype(nv, ov) {
      //切换能源类型刷新页面
      this.dataObject = {};
      switch (this.targetApptype) {
        case 36:
          this.options.title.text = "发电量(KW·h)";
          break;
        case 237:
          this.options.title.text = "用水量(t)";
          break;
        case 361:
          this.options.title.text = "用气量(m³)";
          break;
        case 362:
          this.options.title.text = "用汽量";
          break;
      }
      this.setDataed();
    },
  },
  methods: {
    //获取单位下光伏设备类型树

    heji() {
      this.heji_status = !this.heji_status;

      this.setDataed();
    },
    setDataed() {
      if (this.heji_status) {
        this.options2 = JSON.parse(JSON.stringify(this.options));

        var d = this.options2.series;
        var dataed = [];
        d.map((v, i) => {
          if (!i) {
            v.data.map((a, ii) => {
              if (a[1]) {
                a[1] = Number(a[1]);
              }
            });
            dataed = v;
          } else {
            v.data.map((a, ii) => {
              if (a[1]) {
                dataed.data[ii][1] += Number(a[1]);
              }
            });
          }
        });
        if (dataed.length == 0) {
          return;
        }
        dataed.data.map((v) => {
          if (v[1]) {
            v[1] = v[1].toFixed(2);
          }
        });

        dataed.name = "合计";
        this.options2.series = [dataed];
        this.options2.legend.data = [
          {
            icon: "roundRect",
            name: "合计",
          },
        ];

        this.$refs.vchart.setData(this.options2, true);
      } else {
        this.$refs.vchart.setData(this.options, true);
      }
    },
    digui(data) {
      var device = [];
      var recursiveFunction = function() {
        const getStr = function(list) {
          list.forEach(function(row) {
            if (row.hasOwnProperty("children") && row.children.length != 0) {
              getStr(row.children);
            } else {
              device.push(row);
            }
          });
        };
        getStr(data);
      };
      recursiveFunction();
      this.checkedData = [device[0].no];
      this.$nextTick(() => {
        //默认选中
        this.$refs["tree"].setCheckedNodes([device[0]]);
        this.nowVirtualDevice = [device[0]];
      });
    },
    // 树形筛选
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    tree_fn(v, val) {
      var data = [];
      val.checkedNodes.forEach((item) => {
        if (item.deviceNo) {
          data.push(item);
        }
      });
      console.log("设备", data);
      this.nowVirtualDevice = data;
    },
    select_fn() {},

    selectTimeInterval(ev) {
      this.cacheStore.commit("setNowTimeInterval", ev);
      this.$refs.endPicker.hide();
    },
    getMath(index) {
      if (!index) {
        index = 10;
      }
      var min = index - index / 10; // 确保min是整数
      var max = index + index / 10; // 确保max是整数
      var d = Math.floor(Math.random() * (max - min + 1)) + min;
      if (d) {
        return d.toFixed(2);
      }
      return d;
    },
    search() {
      //先查询设备信息  再查数据
      var d = [
        676,
        32,
        341,
        457,
        78,
        67,
        324,
        435,
        342,
        353,
        122,
        53,
        533,
        46,
        767,
        97,
        56,
        322,
        23,
        343,
        23,
        454,
        42,
        234,
        "3324",
      ];
      d.map((v, i) => {
        d[i] = this.getMath(d[i]);
      });
      this.summary = 0;
      this.dataObject = {
        "永宁机电总进线数显表.正向有功电能_峰": d,
      };
    },
    reloadChart(list) {
      var selected = {};
      var legend = [];
      var seriesList = [];
      for (var i = 0, len = list.length; i < len; i++) {
        let item = list[i];
        var name = list[i].shift();
        seriesList.push({
          name: name,
          type: "bar",
          smooth: true,
          symbol: "emptyCircle",
          sampling: "average",
          data: item,
        });
        selected[name] = i < 12 ? true : false;
        legend.push({
          name: name,
          icon: "roundRect",
        });
      }

      if (this.nowTimetype == "custom" && seriesList[0]) {
        seriesList[0].data = seriesList[0].data.slice(
          0,
          seriesList[0].data.length - 1
        );
      }
      this.options.series = seriesList;
      this.options.legend.data = legend;
      this.options.legend.selected = selected;

      this.options.tooltip.formatter = (params, ticket, callback) => {
        if (params[0].data == undefined) {
          return "";
        }
        var h = params[0].data[0];
        var label = h + "</br>";
        params.forEach((item) => {
          var values;
          if (isnull(item.data[1])) {
            values = "无采集数据";
          } else {
            values = cutDigital(item.data[1]);
          }
          label +=
            item.seriesName + " : " + values + " (" + this.unit + ")</br>";
        });
        return label;
      };
      // switch (this.targetApptype) {
      // 	case 36:
      // 		//this.options.title.text = this.nowVirtualDevice.name + "-用电量"
      // 		this.options.title.text = "用电量"
      // 		break
      // 	case 237:
      // 		this.options.title.text = "用水量"
      // 		break
      // 	case 361:
      // 		this.options.title.text = "用气量"
      // 		break
      // 	case 362:
      // 		this.options.title.text = "用汽量"
      // 		break
      // }
      this.setDataed();
    },
    getQuarterList(date) {
      switch ((date.getMonth() / 3) | 0) {
        case 0:
          return ["一月", "二月", "三月"];
        case 1:
          return ["四月", "五月", "六月"];
        case 2:
          return ["七月", "八月", "九月"];
        case 3:
          return ["十月", "十一月", "十二月"];
      }
    },
    exportExcel() {
      this.nowDevice = [this.nowVirtualDevice];
      let list = this.$store.deviceStore.getters.getReadDeviceTreeWithTypeNos(
        this.targetApptype,
        this.nowUnit.id
      );
      var title = "发电统计";

      switch (this.nowTimetype) {
        case "custom":
          title =
            this.nowTimeInterval.startDate.format("yyyy年MM月dd日") +
            "至" +
            this.nowTimeInterval.endDate.format("yyyy年MM月dd日") +
            "发电统计";
          break;
        case "day":
          title = this.nowSelectDate.format("yyyy年MM月dd日") + "发电统计";
          break;
        case "week":
          let getDate = getMonthWeek(
            this.nowSelectDate.format("yyyy"),
            this.nowSelectDate.format("MM"),
            this.nowSelectDate.format("dd")
          );
          title =
            getDate.getYear +
            "年" +
            getDate.getMonth +
            "月第" +
            getDate.getWeek +
            "周" +
            "发电统计";
          break;
        case "month":
          title = this.nowSelectDate.format("yyyy年MM月") + "发电统计";
          break;
        case "quarter":
          title = "第" + this.nowSelectDate.format("q") + "季发电统计";
          break;
        case "year":
          title = this.nowSelectDate.format("yyyy") + "年发电统计";
          break;
        default:
          title = "发电统计";
      }

      const tHeader = [title];
      this.$refs.downloadTable.export2Excel(
        tHeader,
        this.nowPage,
        title,
        "#printCons"
      );

      // if(this.nowTimetype!='custom') {

      //   this.$api.reportApi.exportHistoryDifferenceRanking(title,this.nowVariableNamesS.join(','),this.nowSelectDate.getTime(),this.nowTimetype,
      //     respon => {
      //       saveAs(DWSystemSetting.downloadUrl+'/'+respon,title+".xls")
      //     })
      // } else {
      //   //时间段的导出
      //   this.$api.reportApi.exportHistoryDifferenceRankingCustom(title,this.nowVariableNamesS.join(','),this.nowTimeInterval.startDate.getTime(),this.nowTimeInterval.endDate.getTime(),this.nowTimetype,
      //     respon => {
      //       saveAs(DWSystemSetting.downloadUrl+'/'+respon,title+".xls")
      //     })
      // }
    },
    exportAllExcel() {
      this.$dialogMethod.showLoading("正在生成报告。。。");
      if (this.nowTimetype != "custom") {
        this.$api.reportApi.exportAllPowerDifferenceRanking(
          this.nowSelectDate.getTime(),
          (respon) => {
            if (!respon.includes("%2F")) {
              this.$dialogMethod.showMessage(respon);
              return;
            }
            saveAs(
              DWSystemSetting.downloadUrl + "/" + respon,
              respon.substring(respon.lastIndexOf("%2F") + 3)
            );
            this.$dialogMethod.closeLoading();
          }
        );
      } else {
        this.$api.reportApi.exportAllPowerDifferenceRankingCustom(
          this.nowTimeInterval.startDate.getTime(),
          this.nowTimeInterval.endDate.getTime(),
          this.nowTimetype,
          (respon) => {
            if (!respon.includes("%2F")) {
              this.$dialogMethod.showMessage(respon);
              return;
            }
            saveAs(
              DWSystemSetting.downloadUrl + "/" + respon,
              respon.substring(respon.lastIndexOf("%2F") + 3)
            );
            this.$dialogMethod.closeLoading();
          }
        );
      }
    },
  },
  filters: {
    // 转换时间戳
    date_format: function(value) {
      //value就是插值的数据
      if (!value) {
        return "";
      }
      let newArr = value.split(".");
      return newArr[0];
    },
  },
};
</script>

<style scoped lang="scss">
.titled {
  display: flex;
  font-weight: bold;
  justify-content: space-between;
  margin-bottom: 5px;
}

/deep/.el-loading-mask {
  background-color: rgba(255, 255, 255, 1) !important;
}

.titled span {
  font-size: 0.16rem;
}

.search-input-btn {
  height: 43px;
}

.usepowerdifference {
  .con {
    width: 100%;
    height: 100%;
    display: flex;

    .tree-left {
      width: 300px;
      height: 100%;
      background-color: #fff;
      margin-right: 8px;
      padding: 12px;
      box-sizing: border-box;
    }

    .right-table {
      width: calc(100% - 308px);
      height: 100%;
      background-color: #fff;
      padding: 2px 20px 12px 20px;
      box-sizing: border-box;
      position: relative;
    }

    /deep/.thable {
      background-color: #368ed9;
    }

    /deep/.infolist-table-body th,
    .infolist-table-body td {
      color: #fff;
    }
  }
}
</style>
